import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// IMPORTAMOS NUESTRO NUEVO MENÚ UNIVERSAL
import Sidebar from './Sidebar';

const Dashboard = () => {
  const navigate = useNavigate();
  const [rolUsuario, setRolUsuario] = useState('');
  const [correoUsuario, setCorreoUsuario] = useState('');

  // Solo desciframos el token rápido para el mensaje de bienvenida del Dashboard
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return navigate('/login');
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setRolUsuario(payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || payload.role || 'Usuario');
      setCorreoUsuario(payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] || payload.email || '');
    } catch (e) { navigate('/login'); }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* AQUÍ INYECTAMOS EL MENÚ INTELIGENTE */}
      <Sidebar />

      {/* ÁREA PRINCIPAL */}
      <main className="flex-1 p-8 bg-slate-50 overflow-y-auto">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-slate-800 mb-2">¡Bienvenido, {rolUsuario}!</h1>
          <p className="text-slate-600 mb-8">Has iniciado sesión como <span className="font-bold text-blue-600">{correoUsuario}</span>. Selecciona una opción del menú lateral para comenzar.</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
              <h2 className="text-lg font-bold text-slate-800 mb-2">Estado del Sistema</h2>
              <p className="text-slate-600 text-sm">Tu conexión está encriptada y segura. Tienes los permisos correspondientes a tu rol de {rolUsuario}.</p>
            </div>
            
            {['SuperAdmin', 'Admin', 'Director'].includes(rolUsuario) && (
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-6 rounded-xl shadow-sm text-white">
                <h2 className="text-lg font-bold mb-2">Panel Administrativo</h2>
                <p className="text-blue-100 text-sm">Recuerda mantener actualizadas las matrículas y los periodos escolares para el correcto funcionamiento del área académica.</p>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;